import { Box, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Styles label for the checkbox.
 */
export const StyledLabel = styled('label')(() => (Object.assign(Object.assign({}, HelixStyles.style_07), { alignItems: 'center', display: 'flex', height: 18, width: 'fit-content' })));
// Common hover and active styles.
const styles = {
    b70: {
        backgroundColor: HelixPalette.teal70,
        borderColor: HelixPalette.teal70,
    },
    b80: {
        backgroundColor: HelixPalette.teal80,
        borderColor: HelixPalette.teal80,
    },
    b90: {
        backgroundColor: HelixPalette.teal90,
        borderColor: HelixPalette.teal90,
    },
};
/**
 * Styled Box used for the Checkbox.
 */
export const StyledCheckbox = styled(Box)(() => ({
    alignItems: 'center',
    border: `2px solid ${HelixPalette.neutral50}`,
    borderRadius: '0.125rem',
    display: 'flex',
    height: 18,
    justifyContent: 'center',
    maxHeight: 18,
    maxWidth: 18,
    minHeight: 18,
    minWidth: 18,
    overflow: 'hidden',
    width: 18,
    svg: { fill: HelixPalette.white },
    '&:focus': { outline: 'none' },
    '&:focus-visible': { outline: HelixStyles.focusVisible5.outline, outlineOffset: HelixStyles.focusVisible5.outlineOffset },
    '&[aria-disabled=false]': {
        '&[aria-checked=false]': {
            borderColor: HelixPalette.neutral50,
            '&:hover': {
                borderColor: HelixPalette.teal70,
                cursor: 'pointer',
            },
            '&:active:focus': { borderColor: HelixPalette.teal90 },
        },
        '&[aria-checked=true]': Object.assign(Object.assign({}, styles.b80), { '&:hover': Object.assign(Object.assign({}, styles.b70), { cursor: 'pointer' }), '&:active:focus': Object.assign({}, styles.b90) }),
        '&[aria-checked=mixed]': Object.assign(Object.assign({}, styles.b80), { '&:hover': Object.assign(Object.assign({}, styles.b70), { cursor: 'pointer' }), '&:active:focus': Object.assign({}, styles.b90) }),
    },
    '&[aria-disabled=true]': {
        backgroundColor: HelixPalette.neutral10,
        borderColor: HelixPalette.neutral50,
        svg: { fill: HelixPalette.neutral50 },
    },
}));
